module.exports = __webpack_public_path__ + "images/bi-logo-big-537257fb.png";